import script from "./UserCards.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCards.vue?vue&type=script&setup=true&lang=js"

import "./UserCards.vue?vue&type=style&index=0&id=00687170&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00687170"]])

export default __exports__